import Quantity from './Quantity';
export default Quantity;
